module.exports = __webpack_public_path__ + "img/search-btn-result-tag-delete.9793303c.svg";